import type { ReactNode } from 'react';
import { TravelCalendar, type TravelCalendarBaseProps } from '../../shared/travel_calendar.js';
import { daysBetween } from '@voll-intelligence/dates';

export type HotelDateRange = { checkin?: string; checkout?: string };

/** A copy do calendário da estadia — a mesma na barra de busca e nos campos da
 *  estadia. */
export type HotelDateCopy = {
  calendarLocale: string;
  previousMonthLabel: string;
  nextMonthLabel: string;
  dateDraftSummary(value: HotelDateRange): string;
  confirmDatesLabel(value: HotelDateRange): string;
  /** O `Confirmar` FIXO da folha estreita ("Confirmar datas", #3446): lá o
   *  par escolhido já está escrito no resumo logo acima, e o rótulo mudando de
   *  tamanho fazia o botão pular. No popover ele segue nomeando o par. */
  confirmDatesSheetLabel: string;
  /** O teto de noites de uma busca: o do fornecedor, que o kit não conhece.
   *  Acima dele o Confirmar das datas trava, e o `dateDraftSummary` diz por quê
   *  (#5662). Ausente ⇒ sem teto. */
  maxStayNights?: number;
};

/** O rascunho passa do teto de noites (`HotelDateCopy.maxStayNights`). */
export function exceedsMaxStay(range: HotelDateRange, maxStayNights: number | undefined): boolean {
  return (
    maxStayNights !== undefined &&
    range.checkin !== undefined &&
    range.checkout !== undefined &&
    daysBetween(range.checkin, range.checkout) > maxStayNights
  );
}

/**
 * O calendário de estadia do hotel: o `TravelCalendar` compartilhado no
 * vocabulário do hotel (check-in/check-out) e com a regra dele — pelo menos
 * uma noite. A grade, as peles e a folha estreita moram no calendário
 * compartilhado; aqui só a tradução.
 */
export function HotelDateCalendar({
  value,
  onChange,
  ...props
}: Omit<TravelCalendarBaseProps, 'value' | 'onChange'> & {
  readonly value: HotelDateRange;
  readonly onChange: (value: HotelDateRange) => void;
}): ReactNode {
  return (
    <TravelCalendar
      {...props}
      value={{ from: value.checkin, to: value.checkout }}
      minNights={1}
      onChange={(range) => {
        onChange({ checkin: range.from, checkout: range.to });
      }}
    />
  );
}
